import { isPlatform } from '@ionic/react'

export const isGooglePixel7MobileWeb = (userAgent: string) =>
  /(Pixel 7| K)/i.test(userAgent) && !isPlatform('hybrid')
